export enum Access {
  COMPANY = 'COMPANY_ACCESS',
  SHOP = 'SHOP_ACCESS',
}
